/**
 * ZaraService — STUB v1.12.485 (RapidAPI désactivé)
 */
export async function getZaraProducts() { return []; }
export function getZaraFallback() { return []; }
